package org.multipaz.wallet.shared

class WalletBackendAlreadySignedInException(message: String? = null): WalletBackendException(message)